const Saee10StatusEnum = Object.freeze({
    Pending: 1,
    Process:2,
    RecommendedExistentResource: 4,
    Canceled: 7,
    RecommendedPendingAssignment:8,
    ApprovedProvisionalRemedy: 10,
    NotRecommendedPendingAssignment: 11,
    InProcessPendingAssignement: 13
});

export { Saee10StatusEnum };
